/**
 * Angular imports.
 */
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Service imports.
 */
import { MasterserviceService } from '../../../../dataservices/master-service/masterservice.service';
import { PostApiService } from '../../../../dataservices/post-api.service';
import { FunCollectionService } from '../../../../common/common-functions/fun-collection.service';
import { MultiLangService } from '../../../../dataservices/master-service/multi-lang.service';
import { JwtDecodeService } from '../../../../dataservices/jwt-decode.service';
import { NewLanguageService } from '../../../../dataservices/new-language/new-language.service';
import { DataStorageService } from '../../../../dataservices/data-storage.service';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';
/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';
import { ACTION_ON, ACTION_TYPE, CTA_TYPE, PRODUCT_TYPE_CONSTANT, PRODUCT_TYPE_CONSTANT_NAME, SCREEN_NAME } from 'src/app/constants/app.constants';

/**
 * WebChannel Card Component
 */
@Component({
  selector: 'app-web-channel-card',
  templateUrl: './web-channel-card.component.html',
  styleUrls: ['./web-channel-card.component.scss']
})
export class WebChannelCardComponent implements OnInit, OnDestroy {

  @Input() docCardObj;
  @Input() docTalkSection;
  @Input() listLength;
  @Input() sectionName;
  public showSubscribeModal = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public subscribe_obj: any;
  public erroMsg = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public tncData: any;
  public displayObj = {
    isShow: false,
    display_section: '',
    data: [],
    errObj: []
  };
  public showSubscribeChecked = true;
  public channelsub: object;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Necessary instances.
   */
  constructor(
    public dss: DataStorageService,
    private masterService: MasterserviceService,
    private jwtSer: JwtDecodeService,
    public multiLangService: MultiLangService,
    public fcs: FunCollectionService,
    private router: Router,
    public postSer: PostApiService,
    private analyticSdk: Analytics,
    public mls: NewLanguageService) { }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.subscribe_obj = { 'target_id': this.docCardObj.target_id, 'channel_name': this.docCardObj.channel_name, 'tnc_url': this.docCardObj.channel_tnc, 'target_name': this.docCardObj.target_name, 'publication_logo': this.docCardObj.target_image, 'calling_from': 'channel_card' };
  }

  /**
   * show Subscribe Popup
   */
  showSubscribePopup(): void {
    this.showSubscribeModal = true;
  }

  /**
   * Reset subscribe
   */
  resetProductSubscribeModal(status): void {

    if (status == true) {
      this.docCardObj.is_subscribed = 1;
    }
    this.showSubscribeModal = false;
  }

  /**
   * Navigate to detail pharma
   */
  navigatetodetail(id): boolean {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.CHANNEL, id, this.fcs.currentScreename, CTA_TYPE.CARD, ACTION_TYPE.CLICK, ACTION_ON.CHANNEL, null);
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }
    this.router.navigateByUrl('channel/pharma/detail/' + id);
  }

  /**
   * Navigate channel detail.
   */
  navigatetoChanneldetail(id): boolean {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.CHANNEL, id, this.fcs.currentScreename, CTA_TYPE.CARD, ACTION_TYPE.CLICK, ACTION_ON.CHANNEL, null);
    if (this.masterService.isOnline === false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }

    this.router.navigateByUrl('channel/detail/' + id);

  }

  /**
   * Navigate to detail channel pharma
   */
  navigatetochannelPhardetail(id): boolean {

    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }
    this.router.navigateByUrl('webchannel/detail/' + id);
  }

  /**
   * show Subscribe
   */
  showSubscribe(safe_url): void {
    if (this.showSubscribeChecked == false) {
      this.erroMsg = true;
    } else if (this.showSubscribeChecked == true) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.CHANNEL,this.docCardObj.target_id, this.fcs.currentScreename, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.CHANNEL_SUBSCRIBED,null);
      this.erroMsg = false;
      this.subscriptions.add(this.postSer.channelSubscribe(safe_url).subscribe(resData => {
        this.jwtSer.decodeData(resData).then(data => {
          if (data['status'] == 1) {
            this.docCardObj.is_subscribed = 1;
            this.fcs.showSuccess(data['msg'], 'Success');
            this.docCardObj.is_product_view = 1;
          } else if (data['status'] == 0) {
            this.fcs.errorHandeler(data);
          }
        });
      }));
    }
  }

  /**
   * show tnc
   */
  showtnc(): void {
    this.tncData = { tnc_url: this.docCardObj.tnc_url, safeurl: this.docCardObj.safe_url, display_section: 'showtnc' };

    this.displayObj.isShow = true;
    this.displayObj.display_section = 'showtnc';
    this.displayObj.data = this.tncData;
    this.masterService.showWebModal.next(this.displayObj);
  }

  /**
   * change
   */
  change(e): void {
    if (e.target.checked == true) {
      this.showSubscribeChecked = true;
    } else {
      this.showSubscribeChecked = false;
    }
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
